import { sample } from 'openapi-sampler';
export var generateExampleSchema = function (schema) {
    try {
        return sample(schema);
    }
    catch (e) {
        return;
    }
};
//# sourceMappingURL=generateExampleSchema.js.map